// extracted by mini-css-extract-plugin
module.exports = {"container":"ingredientsComponent_container__B3Yr_","ingredients":"ingredientsComponent_ingredients__60Hfu","ingredient":"ingredientsComponent_ingredient__Rc6k8"};